import React from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationButtons = ({ nextPath, prevPath, nextLabel = 'Continuer', onNext }) => {
  const navigate = useNavigate();

  // `onNext` peut renvoyer `false` pour bloquer l'étape (saisie invalide).
  const handleNext = () => {
    if (onNext && onNext() === false) return;
    if (nextPath) {
      navigate(nextPath);
    }
  };

  const handleBack = () => {
    if (prevPath) {
      navigate(prevPath);
    }
  };

  return (
    <div className="button-group">
      {nextPath && (
        <button className="btn btn--primary" onClick={handleNext}>
          {nextLabel} &gt;
        </button>
      )}
      {prevPath ? (
        <button className="btn btn--outline" onClick={handleBack}>
          &lt; Retour
        </button>
      ) : (
        <button className="btn btn--outline" style={{ visibility: 'hidden' }} aria-hidden="true">&nbsp;</button>
      )}
    </div>
  );
};

export default NavigationButtons;
